<style scoped lang="scss">
    @import "../../../../sass/variables";

    .main {
        background-color: $color-bg;
        min-height: 1000px;
    }
</style>

<template>
    <div class="main">
        <bcms-nav></bcms-nav>
        <bcms-header :marginTop="58"></bcms-header>
        <bcms-subjects></bcms-subjects>
        <bcms-articles></bcms-articles>
    </div>
</template>

<script>
    import bcmsNav from "./nav";
    import bcmsHeader from "./header";
    import bcmsSubjects from "./subjects";
    import bcmsArticles from "./articles";

    export default {
        components: {
            "bcms-nav": bcmsNav,
            "bcms-header": bcmsHeader,
            "bcms-subjects": bcmsSubjects,
            "bcms-articles": bcmsArticles
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/web/components/index/index.vue